<template>
    <div class="desktop">
        <div>
            <div class="desktop__device"><iframe src="/?forceIframe=true" width="360px" height="640px" border="none" /></div>
            <div>Swipe met je muis..</div>
        </div>
    </div>
</template>

<script>
export default {};
</script>
